import { ReactNode } from "react";

import messages from "../messages/ja.json";
import { FeVersion } from "./fe-version";

import "../styles/verify-mfa.css";

interface Props {
  username?: string;
  children: ReactNode;
  footer?: ReactNode;
}

// Full-page shell for the verify-mfa (顔認証) flow. Deliberately independent from the
// face-registration shell — its own markup + CSS namespace (.verify-mfa-*) so styling
// changes on either screen never affect the other.
export function VerifyMfaShell({ username, children, footer }: Props) {
  return (
    <main className="verify-mfa-shell">
      <header className="verify-mfa-header prev-header">
        {username ? (
          <div className="verify-mfa-user">
            <span className="verify-mfa-user-label">{messages.auth.userLabel}</span>
            <span className="verify-mfa-user-value">{username}</span>
          </div>
        ) : null}
        <FeVersion className="fe-version-corner" />
        <h1 className="verify-mfa-title">{messages.checkin.title}</h1>
        <p className="verify-mfa-description">{messages.checkin.description}</p>
      </header>

      <div className="verify-mfa-body">{children}</div>

      {footer ? <footer className="verify-mfa-footer">{footer}</footer> : null}
    </main>
  );
}
